<template>
  <div class="tile is-ancestor">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="table-responsive">
          <table class="table is-bordered is-striped is-narrow">
            <thead>
            <tr>
              <th @click="sort('name')">Название{{sortIcon('name')}}</th>
              <th @click="sort('client')">Автор{{sortIcon('client')}}</th>
              <th @click="sort('scenario')">Сценарий{{sortIcon('scenario')}}</th>
              <th @click="sort('date')">Прозвон{{sortIcon('date')}}</th>
              <th @click="sort('state')">Статус{{sortIcon('state')}}</th>
              <th @click="sort('dateCreated')">Дата создания{{sortIcon('dateCreated')}}</th>
              <th @click="sort('sumConsume')">Сумма{{sortIcon('sumConsume')}}</th>
              <th>Отчет</th>
              <th>Действие</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="campaign in sortedCampaigns">
              <td>
                <a :href="'#/campaigns/'+campaign.id">{{campaign.name}}</a>
              </td>
              <td>
                {{campaign.client}}
              </td>
              <td>
                {{campaign.scenario}}
              </td>
              <td>
                {{campaign.date}} {{campaign.timeStart}}-{{campaign.timeEnd}} {{campaign.zoneOffset}} UTC
              </td>
              <td>
                {{campaign.state}}
              </td>
              <td>
                {{getDate(campaign.dateCreated)}}
              </td>
              <td>
                {{campaign.sumConsume}}
              </td>
              <td>
                <div v-if="campaign.state=='Завершена'" class="dropdown">
                  <div class="dropdown__header" @click="toggleDropdown($event)">
                    <button class="button is-info" style="width:100%">
                      <span>Отчеты</span>
                    </button>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                  </div>
                  <div class="dropdown__content">
                    <ul>
                      <li>
                        <button class="button is-info" v-on:click="getReportCSV(campaign)" style="width:100%">
                              <span class="icon">
                                <i class="fa fa-download"></i>
                              </span>
                          <span>Отчет в CSV</span>
                        </button>
                      </li>
                      <li>
                        <a :href="'/report/reportByCampaignId.xls?campaignId=' + campaign.id"  tag="button">
                          <button class="button is-info" style="width:100%">
                                <span class="icon">
                                  <i class="fa fa-download"></i>
                                </span>
                            <span>Отчет в XLS</span>
                          </button>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
              <td>
                <a v-if="canCreate(permissionKey)" :href="'#/campaigns/copy/'+campaign.id"  :disabled="!isActive" class="button is-success"  style="width:100%">
                  <span class="icon">
                    <i class="fa fa-copy"></i>
                  </span>
                  <span>Копировать</span>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div id="page-navigation">
          <ul class="pagination">
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickFirstPage"
                :disabled="isInFirstPage"
                aria-label="Go to first page"
              >
                Первая
              </button>
            </li>
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickPreviousPage"
                :disabled="isInFirstPage"
                aria-label="Go to previous page"
              >
                Предыдущая
              </button>
            </li>
            <li v-for="page in pages" class="pagination-item">
              <button
                type="button"
                @click="onClickPage(page.name)"
                :disabled="page.isDisabled"
                :class="{ activepage: isPageActive(page.name) }"
                :aria-label="`Go to page number ${page.name}`"
              >
                {{ page.name }}
              </button>
            </li>
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickNextPage"
                :disabled="isInLastPage"
                aria-label="Go to next page"
              >
                Следующая
              </button>
            </li>
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickLastPage"
                :disabled="isInLastPage"
                aria-label="Go to last page"
              >
                Последняя
              </button>
            </li>
          </ul>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import Message from 'vue-bulma-message'
  import CheckToken from '../authentication/CheckToken'
  import CheckPermission from '../authentication/CheckPermission'

  Vue.mixin(CheckToken)
  Vue.mixin(CheckPermission)

  const MessageComponent = Vue.extend(Message)
  const openMessage = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  }) => {
    return new MessageComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const GET_ARCHIVE_LIST_API = '/api/campaigns/archive'
  const PROFILES_API = '/api/profiles'

  export default {

    data () {
      return {
        campaigns: [],
        sortedCampaigns: [],
        currentPage: 1,
        perPage: 10,
        maxVisibleButtons: 10,
        currentSort: 'dateCreated',
        currentSortDir: 'asc',
        ascIcon: ' ▲',
        descIcon: ' ▼',
        isActive: false,
        permissionKey: 'campaign'
      }
    },

    created: function () {
      this.checkToken()
      this.loadState()
      this.loadData()
    },

    computed: {
      ...mapGetters([
        'loggedId',
        'authenticationToken'
      ]),
      totalPages() {
        return Math.max(Math.ceil(this.campaigns.length / this.perPage), 1)
      },
      startPage() {
        if (this.currentPage === 1) {
          return 1
        }

        if (this.currentPage === this.totalPages) {
          return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1)
        }

        return this.currentPage - 1
      },
      endPage() {
        return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
      },
      pages() {
        const range = []
        for (let i = this.startPage; i <= this.endPage; i += 1) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage
          })
        }
        return range
      },
      isInFirstPage() {
        return this.currentPage === 1
      },
      isInLastPage() {
        return this.currentPage === this.totalPages
      }
    },

    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadData () {
        this.$http.get(GET_ARCHIVE_LIST_API, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.campaigns = response.data
            this.sortedCampaigns = this.sortedCamp()
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки списка архивных рассылок. ')
          })
      },
      loadState () {
        this.$http({
          url: PROFILES_API + '/activeState/' + this.loggedId,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          this.isActive = response.data
          if (!this.isActive) {
            openMessage({
              message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
              type: 'danger',
              showCloseButton: true
            })
          }
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ')
        })
      },
      getReportCSV (campaign) {
        this.$http.get('/report/reportByCampaignId.csv?campaignId=' + campaign.id)
          .then((response) => {
            let blob = new Blob([response.data], { type: 'text/csv' })
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob)
            a.download = 'ReportByCampaign_' + campaign.name + '.csv'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          })
          .catch((error) => {
            this.openNotificationWithType('danger', 'Ошибка загрузки отчета')
            console.log(error)
          })
      },
      getDate(date) {
        var d = new Date(Number(date))
        var day = d.getUTCDate()
        var month = d.getUTCMonth() + 1
        var year = d.getUTCFullYear()
        if (day < 10) day = '0' + day
        if (month < 10) month = '0' + month
        return day + '.' + month + '.' + year
      },
      sortedCamp() {
        return this.campaigns.sort((a, b) => {
          let modifier = 1
          if (this.currentSortDir === 'desc') modifier = -1
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
          return 0
        }).filter((row, index) => {
          let start = (this.currentPage - 1) * this.perPage
          let end = this.currentPage * this.perPage
          if (index >= start && index < end) return true
        })
      },
      sort(s) {
        // if s == current sort, reverse
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
        }
        this.currentSort = s
        this.sortedCampaigns = this.sortedCamp()
      },
      sortIcon(s) {
        if (s === this.currentSort) {
          if (this.currentSortDir === 'asc') {
            return this.ascIcon
          } else {
            return this.descIcon
          }
        } else {
          return ''
        }
      },
      onClickFirstPage() {
        this.onPageChange(1)
      },
      onClickPreviousPage() {
        this.onPageChange(this.currentPage - 1)
      },
      onClickPage(page) {
        this.onPageChange(page)
      },
      onClickNextPage() {
        this.onPageChange(this.currentPage + 1)
      },
      onClickLastPage() {
        this.onPageChange(this.totalPages)
      },
      isPageActive(page) {
        return this.currentPage === page
      },
      onPageChange(page) {
        this.currentPage = page
        this.sortedCampaigns = this.sortedCamp()
      },
      toggleDropdown (event) {
        event.currentTarget.classList.toggle('is-active')
      }
    }
  }

</script>

<style lang="scss">

  .pagination {
    list-style-type: none;
  }

  .pagination-item {
    display: inline-block;
  }

  .activepage {
    background-color: #4AAE9B;
    color: #ffffff;
  }

  .table > thead > tr > th {
    text-align: center;
  }

  .dropdown {
    &__header {
      position: relative;
      i.fa {
        position: absolute;
        right: 10px;
        top: 35%;
        transform: translateY(-50%);
        transition: opacity .3s;
        color: white;
        &.fa-angle-up {
          opacity: 0;
        }
      }
      &.is-active {
        i.fa {
          &.fa-angle-up {
            opacity: 1;
          }
          &.fa-angle-down {
            opacity: 0;
          }
        }
        + .dropdown__content {
          height: auto;
          opacity: 1;
          visibility: visible;
        }
      }
    }
    &__content {
      height: 0;
      opacity: 0;
      overflow: hidden;
      transition: opacity .3s;
      visibility: hidden;
    }
  }

</style>



// WEBPACK FOOTER //
// Archive.vue?6fd4a956